<template>
  <div
    class="
      relative
      py-3
      lg:py-4
      px-3
      lg:px-6
      bg-white-005
      rounded-2xl
      flex-1 flex flex-col
    "
  >
    <div class="text-sm lg:text-xl font-bold mb-6">Top Voters</div>

    <div
      class="
        flex
        h-10
        justify-between
        items-center
        text-xs
        lg:text-base
        text-white-070
      "
    >
      <div class="pl-0 lg:p-2" style="width: 8.89%">#</div>
      <div class="pl-0 lg:p-2" style="width: 19.63%">Address</div>
      <div class="pl-0 lg:p-2" style="width: 16.3%">
        <Sort v-model="state.sortValue" index="0">DAOs</Sort>
      </div>
      <div class="pl-0 lg:p-2" style="width: 20%">
        <Sort v-model="state.sortValue" index="1" custom="justify-end"
          >Proposals</Sort
        >
      </div>
      <div class="pl-0 lg:p-2" style="width: 15%">
        <Sort v-model="state.sortValue" index="2" custom="justify-end"
          >Votes</Sort
        >
      </div>
      <div class="pl-0 lg:p-2" style="width: 20.19%">
        <Sort v-model="state.sortValue" index="3" custom="justify-end"
          >Proposed</Sort
        >
      </div>
    </div>

    <div class="flex-1 min-h-0 text-xs lg:text-base">
      <div class="w-full h-full overflow-y-scroll" ref="container">
        <div v-if="results.length > 0" class="space-y-2">
          <div
            class="
              flex
              justify-between
              items-center
              hover:bg-white-005
              rounded
              w-full
              h-12
              cursor-pointer
            "
            v-for="(item, index) in results"
            :key="index"
          >
            <div style="width: 8.89%" class="pl-0 lg:pl-2 font-bold">
              {{ index + 1 }}
            </div>
            <div style="width: 19.63%" class="flex items-center pl-0 lg:pl-2">
              <div class="text-secondary-7 underline line-clamp-1">
                <EnsAddress :address="item.address" :size="3"></EnsAddress>
              </div>
            </div>
            <!-- {{ item.daos }} -->
            <div
              style="width: 16.3%"
              class="pl-0 lg:pl-2"
              @click.stop="
                () => {
                  /*  */
                }
              "
            >
              <tippy
                allowHTML
                :arrow="false"
                interactive
                :trigger="isLargeScreen ? undefined : 'click'"
                :popperOptions="{ escapeWithReference: false }"
                :maxWidth="306"
                :onShow="onTipShow"
              >
                <div
                  class="
                    flex
                    items-center
                    pl-1
                    bg-white-005
                    h-6
                    lg:h-8
                    rounded-full
                  "
                >
                  <UiImg
                    class="w-3 lg:w-6 h-3 lg:h-6 rounded-full overflow-hidden"
                    v-for="(dao, j) in item.daos.slice(0, 2)"
                    :key="j"
                    :src="dao.logo"
                    :class="{
                      '-ml-1': j != 0,
                    }"
                  ></UiImg>
                  <div
                    class="w-2 h-2 bg-mb-red rounded-full -ml-1"
                    v-if="item.daos.length > 2"
                  ></div>
                  <span class="font-bold text-xs" v-if="item.daos.length > 2">
                    +{{ item.daos.length - 2 }}
                  </span>
                </div>

                <template #content>
                  <div class="flex flex-wrap items-center">
                    <router-link
                      :to="`/dao/${daox.daoPath}`"
                      v-for="(daox, jx) in item.daos"
                      :key="jx"
                      class="p-2"
                    >
                      <UiImg
                        class="h-10 w-10 overflow-hidden rounded-full"
                        :src="
                          daox.logo || require('@/assets/icons/nftnologo.avif')
                        "
                    /></router-link>
                  </div>
                </template>
              </tippy>
            </div>
            <div style="width: 20%" class="pr-2 text-right font-bold">
              {{ formatVal(item.proposals, { omit: true, bit: 0 }) }}
            </div>
            <div style="width: 15%" class="pr-2 text-right font-bold">
              {{ formatVal(item.votes, { omit: true, bit: 0 }) }}
            </div>
            <div style="width: 20.19%" class="pr-2 text-right font-bold">
              {{ formatVal(item.proposalsCreated, { omit: true, bit: 0 }) }}
            </div>
          </div>
        </div>
        <div v-if="loading" class="flex justify-center items-center h-10">
          <Spin></Spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Spin from '@/components/Spin.vue';
import Sort from '@/components/Sort.vue';
import { reactive, ref, inject, onMounted, watch } from 'vue';
import { useDesktop, useReqPages } from '@/hooks';
import { getHomeVoterRank } from '@/api/dao';
import { useInfiniteScroll } from '@vueuse/core';
import { homeChains, homeTypes } from './constant';
import { formatAddress, formatVal } from '@/utils';
import UiImg from '@/components/UiImg.vue';
import { withThrottling } from '@/utils/with';
import EnsAddress from './component/EnsAddress.vue';

const state = reactive({
  sortValue: [-1, 0, -1, -1],
});

const container = ref(null);
const homeState = inject('homeState');
const isLargeScreen = useDesktop();

const sortKey = ['daos', 'proposals', 'votes', 'proposalsCreated'];

/* 
  daoCategory
  daoPath
  logo
  name
 */

const { loadRest, loadNext, loading, results } = useReqPages(
  async (page, cancel) => {
    const index = state.sortValue.findIndex((x) => x != -1);

    const res = await getHomeVoterRank(
      homeTypes[homeState.selectedType].value,
      homeChains[homeState.selectedChain].value,
      page,
      {
        page,
        orderItem: sortKey[index],
        orderType: state.sortValue[index] != 1 ? 'desc' : 'asc',
      },
      cancel,
    );

    /* TODO */
    const result = {
      lists: res.records,
      rows: res.size,
      total: res.total,
      pages: res.pages,
    };
    return result;
  },
);

useInfiniteScroll(container, withThrottling(loadNext), {
  distance: 44,
});

watch(
  () =>
    JSON.stringify(state.sortValue) +
    homeState.selectedType +
    homeState.selectedChain,
  () => {
    loadRest(true);
  },
);

const jump = (address) => {
  window.open(`https://snapshot.org/#/profile/${address}`, '_blank');
};

onMounted(loadRest);
</script>

<style lang="scss" scoped></style>
